import React, { useState, useEffect } from "react";
import { Tabs, Radio, Tag, Button, Checkbox, Form, Select } from "antd";

const { TabPane } = Tabs;
const responsibleOptions = [
  { label: "PickUp", value: "pick_up" },
  { label: "DropOff", value: "drop_off" },
];
const timeOptions = [
  "Not setting a time",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
];

const CustomScheduleType = (props) => {
  const {
    days = [],
    parentTimeState = {},
    parentCombinations,
    setParentCombinationsV2,
    parentCombinationsV2,
    parentId,
    modified,
    setParentCombinations,
  } = props;

  const [dayState, setDayState] = useState({});
  const [sameForAll, setSameForAll] = useState(false);
  const [sameForAllState, setSameForAllState] = useState({
    responsible_for: undefined,
    time: undefined,
  });
  const [updatedDays, setUpdatedDays] = useState(days);
  const [showCustom, setShowCustom] = useState(false);
  const [customHour, setCustomHour] = useState();
  const [customMinute, setCustomMinute] = useState();

  const combo = parentCombinationsV2?.find(
    (c) =>
      String(c.coparent_combination_id || c.id) === String(props.activeComboId)
  );
  const isSameScheduleForAll =
    combo?.isSameScheduleForAll || combo?.apply_same_settings_for_children;
  useEffect(() => {
    // Find the correct combo and child
    const combo = parentCombinationsV2?.find(
      (c) =>
        String(c.coparent_combination_id || c.id) ===
        String(props.activeComboId)
    );
    if (!combo) return;
    let child = [];
    if (isSameScheduleForAll) {
      child = combo?.children[0];
    } else {
      child = combo.children?.find(
        (c) => String(c?.child_id || c?.id) === String(props.activeChildId)
      );
    }
    if (!child) return;

    // Determine which parent this CustomScheduleType is for
    const parentKey = parentId || "parent1";
    const parentData = child[parentKey];
    const newDays = parentData?.selected_days || days;
    setUpdatedDays(newDays);
    // If "Same for all" is set
    if (parentData?.apply_same_time_all_days) {
      setSameForAll(true);
      setSameForAllState({
        responsible_for: parentData.responsible_for,
        time:
          parentData.pickup_time === null && parentData.dropoff_time === null
            ? "Not setting a time"
            : parentData.responsible_for === "drop_off"
            ? parentData.dropoff_time
            : parentData.pickup_time,
      });
      // Also set all days in dayState for consistency
      const initial = {};
      (parentData.selected_days || []).forEach((day) => {
        initial[day] = {
          responsible_for: parentData.responsible_for,
          time:
            parentData.pickup_time === null && parentData.dropoff_time === null
              ? "Not setting a time"
              : parentData.responsible_for === "drop_off"
              ? parentData.dropoff_time
              : parentData.pickup_time,
        };
      });
      setDayState(initial);
    } else {
      setSameForAll(false);
      // Build per-day state from parentData.days
      const initial = {};
      if (parentData?.days && Array.isArray(parentData?.days)) {
        parentData.days &&
          parentData.days.length &&
          parentData.days.forEach((entry) => {
            initial[entry.day] = {
              responsible_for: entry.responsible_for,
              time:
                parentData.pickup_time === null &&
                parentData.dropoff_time === null
                  ? "Not setting a time"
                  : parentData.responsible_for === "drop_off"
                  ? parentData.dropoff_time
                  : parentData.pickup_time,
            };
          });
      }
      setDayState(initial);
    }
  }, [props.activeComboId, props.activeChildId]);

  const handleResponsibleChange = (day, value) => {
    setDayState((prev) => {
      const newState = {
        ...prev,
        [day]: { ...prev[day], responsible_for: value },
      };
      // saveCustomSchedule(newState);
      return newState;
    });
  };

  const handleTimeChange = (day, value) => {
    if (sameForAll && Array.isArray(day)) {
      // For "same for all" case → update every day
      setSameForAllState((prev) => ({ ...prev, time: value }));
      setDayState((prev) => {
        const newState = { ...prev };
        day.forEach((d) => {
          newState[d] = { ...newState[d], time: value };
        });
        return newState;
      });
    } else {
      // For per-day
      setDayState((prev) => {
        const newState = {
          ...prev,
          [day]: { ...prev[day], time: value },
        };
        return newState;
      });
    }
  };

  useEffect(() => {
    if (Object.keys(dayState).length) {
      saveCustomSchedule(dayState);
    }
  }, [dayState, sameForAllState, sameForAll]);

  const updateChildWithCustomSchedule = (child, combo, currentDayState) => {
    const parentKey = parentId || "parent1";
    const parentIdKey = parentKey === "parent1" ? "parent1_id" : "parent2_id";

    const parentUserId = combo[parentKey]?.user_id;

    if (
      !isSameScheduleForAll &&
      String(child?.child_id ?? child?.id) !== String(props.activeChildId)
    ) {
      return child;
    }
    // === SAME FOR ALL ===
    if (sameForAll) {
      return {
        ...child,
        [parentKey]: {
          ...(child[parentKey] || {}),
          [parentIdKey]: parentUserId,
          apply_same_time_all_days: 1,
          selected_days: updatedDays || days,
          days: [],
          responsible_for: sameForAllState.responsible_for,
          ...(sameForAllState.responsible_for === "pick_up"
            ? {
                pickup_time:
                  sameForAllState.time === "Not setting a time"
                    ? null
                    : sameForAllState.time || currentDayState[days[0]]?.time,
              }
            : {
                dropoff_time:
                  sameForAllState.time === "Not setting a time"
                    ? null
                    : sameForAllState.time || currentDayState[days[0]]?.time,
              }),
        },
        modified,
      };
    }

    // === PER-DAY ===
    const perDayDetails = updatedDays
      .map((day) => {
        const state = currentDayState[day] || {};
        if (!state.responsible_for) return null;

        return {
          day: [day], // 👈 wrap in array like desired payload
          responsible_for: state.responsible_for,
          ...(state.responsible_for === "pick_up"
            ? {
                pickup_time:
                  state.time === "Not setting a time" ? null : state.time,
              }
            : {
                dropoff_time:
                  state.time === "Not setting a time" ? null : state.time,
              }),
        };
      })
      .filter(Boolean);

    return {
      ...child,
      [parentKey]: {
        ...(child[parentKey] || {}),
        [parentIdKey]: parentUserId,
        apply_same_time_all_days: 0,
        selected_days: updatedDays,
        days: perDayDetails,
      },
      modified,
    };
  };

  const saveCustomSchedule = (currentDayState = dayState) => {
    const updateFn = (prev) =>
      prev.map((combo) => {
        if (
          String(combo.coparent_combination_id ?? combo.id) !==
          String(props.activeComboId)
        )
          return combo;

        return {
          ...combo,
          children: combo.children.map((child) =>
            updateChildWithCustomSchedule(child, combo, currentDayState)
          ),
        };
      });

    setParentCombinations(updateFn);
    setParentCombinationsV2(updateFn);
  };

  return (
    <div>
      <Checkbox
        checked={sameForAll}
        onChange={(e) => setSameForAll(e.target.checked)}
        style={{ marginBottom: 16 }}
      >
        Same for all
      </Checkbox>

      {sameForAll ? (
        <Form layout="vertical">
          <Form.Item label="Responsible For" required>
            <Radio.Group
              options={responsibleOptions}
              value={sameForAllState.responsible_for}
              onChange={(e) =>
                setSameForAllState((prev) => ({
                  ...prev,
                  responsible_for: e.target.value,
                }))
              }
            />
          </Form.Item>
          {sameForAllState.responsible_for && (
            <Form.Item label="Time" required>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {timeOptions.map((option) => (
                  <Tag.CheckableTag
                    key={option}
                    checked={sameForAllState.time === option}
                    onChange={() => handleTimeChange(days, option)}
                    style={{
                      borderRadius: 8,
                      padding: "4px 12px",
                      backgroundColor:
                        sameForAllState.time === option ? "#f3e8ff" : "#f6f6f6",
                      color:
                        sameForAllState.time === option ? "#9A4FE0" : "#000",
                    }}
                  >
                    {option}
                  </Tag.CheckableTag>
                ))}
                {customHour !== undefined && customMinute !== undefined && (
                  <Tag.CheckableTag
                    key="custom"
                    checked={
                      sameForAllState.time ===
                      `${String(customHour).padStart(2, "0")}:${String(
                        customMinute
                      ).padStart(2, "0")}`
                    }
                    onChange={() =>
                      handleTimeChange(
                        days,
                        `${String(customHour).padStart(2, "0")}:${String(
                          customMinute
                        ).padStart(2, "0")}`
                      )
                    }
                    style={{
                      borderRadius: 8,
                      padding: "4px 12px",
                      backgroundColor:
                        sameForAllState.time ===
                        `${String(customHour).padStart(2, "0")}:${String(
                          customMinute
                        ).padStart(2, "0")}`
                          ? "#f3e8ff"
                          : "#f6f6f6",
                      color:
                        sameForAllState.time ===
                        `${String(customHour).padStart(2, "0")}:${String(
                          customMinute
                        ).padStart(2, "0")}`
                          ? "#9A4FE0"
                          : "#000",
                    }}
                  >
                    {`${String(customHour).padStart(2, "0")}:${String(
                      customMinute
                    ).padStart(2, "0")}`}
                  </Tag.CheckableTag>
                )}
                <Button
                  type={showCustom ? "primary" : "dashed"}
                  onClick={() => setShowCustom(!showCustom)}
                >
                  Customize...
                </Button>
              </div>
              {showCustom && (
                <div
                  style={{
                    marginTop: 16,
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                  }}
                >
                  <Select
                    placeholder="HH"
                    value={customHour}
                    onChange={setCustomHour}
                    style={{ width: 80 }}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <Select.Option key={i} value={i}>
                        {String(i).padStart(2, "0")}
                      </Select.Option>
                    ))}
                  </Select>
                  <span>:</span>
                  <Select
                    placeholder="MM"
                    value={customMinute}
                    onChange={setCustomMinute}
                    style={{ width: 80 }}
                  >
                    {[0, 15, 30, 45].map((i) => (
                      <Select.Option key={i} value={i}>
                        {String(i).padStart(2, "0")}
                      </Select.Option>
                    ))}
                  </Select>
                  <Button
                    type="primary"
                    disabled={
                      customHour === undefined || customMinute === undefined
                    }
                    onClick={() => {
                      const customTime = `${String(customHour).padStart(
                        2,
                        "0"
                      )}:${String(customMinute).padStart(2, "0")}`;
                      handleTimeChange(days, customTime);
                      setShowCustom(false);
                      console.log("Save clicked");
                    }}
                  >
                    Save
                  </Button>
                </div>
              )}
            </Form.Item>
          )}
        </Form>
      ) : (
        <Tabs type="card">
          {updatedDays.map((day) => (
            <TabPane tab={day} key={day}>
              <Form layout="vertical">
                <Form.Item label="Responsible For" required>
                  <Radio.Group
                    options={responsibleOptions}
                    value={dayState[day]?.responsible_for}
                    onChange={(e) =>
                      handleResponsibleChange(day, e.target.value)
                    }
                  />
                </Form.Item>
                {dayState[day]?.responsible_for && (
                  <Form.Item label="Time" required>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {timeOptions.map((option) => (
                        <Tag.CheckableTag
                          key={option}
                          checked={dayState[day]?.time === option}
                          onChange={() => handleTimeChange(day, option)}
                          style={{
                            borderRadius: 8,
                            padding: "4px 12px",
                            backgroundColor:
                              dayState[day]?.time === option
                                ? "#f3e8ff"
                                : "#f6f6f6",
                            color:
                              dayState[day]?.time === option
                                ? "#9A4FE0"
                                : "#000",
                          }}
                        >
                          {option}
                        </Tag.CheckableTag>
                      ))}
                      {customHour !== undefined &&
                        customMinute !== undefined && (
                          <Tag.CheckableTag
                            key="custom"
                            checked={
                              dayState[day]?.time ===
                              `${String(customHour).padStart(2, "0")}:${String(
                                customMinute
                              ).padStart(2, "0")}`
                            }
                            onChange={() =>
                              handleTimeChange(
                                day,
                                `${String(customHour).padStart(
                                  2,
                                  "0"
                                )}:${String(customMinute).padStart(2, "0")}`
                              )
                            }
                            style={{
                              borderRadius: 8,
                              padding: "4px 12px",
                              backgroundColor:
                                dayState[day]?.time ===
                                `${String(customHour).padStart(
                                  2,
                                  "0"
                                )}:${String(customMinute).padStart(2, "0")}`
                                  ? "#f3e8ff"
                                  : "#f6f6f6",
                              color:
                                dayState[day]?.time ===
                                `${String(customHour).padStart(
                                  2,
                                  "0"
                                )}:${String(customMinute).padStart(2, "0")}`
                                  ? "#9A4FE0"
                                  : "#000",
                            }}
                          >
                            {`${String(customHour).padStart(2, "0")}:${String(
                              customMinute
                            ).padStart(2, "0")}`}
                          </Tag.CheckableTag>
                        )}
                      <Button
                        type={showCustom ? "primary" : "dashed"}
                        onClick={() => setShowCustom(!showCustom)}
                      >
                        Customize...
                      </Button>
                    </div>
                    {showCustom && (
                      <div
                        style={{
                          marginTop: 16,
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                        }}
                      >
                        <Select
                          placeholder="HH"
                          value={customHour}
                          onChange={setCustomHour}
                          style={{ width: 80 }}
                        >
                          {Array.from({ length: 24 }, (_, i) => (
                            <Select.Option key={i} value={i}>
                              {String(i).padStart(2, "0")}
                            </Select.Option>
                          ))}
                        </Select>
                        <span>:</span>
                        <Select
                          placeholder="MM"
                          value={customMinute}
                          onChange={setCustomMinute}
                          style={{ width: 80 }}
                        >
                          {[0, 15, 30, 45].map((i) => (
                            <Select.Option key={i} value={i}>
                              {String(i).padStart(2, "0")}
                            </Select.Option>
                          ))}
                        </Select>
                        <Button
                          type="primary"
                          disabled={
                            customHour === undefined ||
                            customMinute === undefined
                          }
                          onClick={() => {
                            const customTime = `${String(customHour).padStart(
                              2,
                              "0"
                            )}:${String(customMinute).padStart(2, "0")}`;
                            handleTimeChange(day, customTime);
                            setShowCustom(false);
                            console.log("Save Clicked");
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    )}
                  </Form.Item>
                )}
              </Form>
            </TabPane>
          ))}
        </Tabs>
      )}
    </div>
  );
};

export default CustomScheduleType;
